import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '../api/endpoints';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('dasna_user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dasna_token');
    if (!token) { setLoading(false); return; }
    authApi.me()
      .then((res) => {
        setUser(res.data);
        localStorage.setItem('dasna_user', JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem('dasna_token');
        localStorage.removeItem('dasna_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await authApi.login(username, password);
    const { access_token, role, username: uname } = res.data;
    localStorage.setItem('dasna_token', access_token);
    const u = { username: uname, role };
    localStorage.setItem('dasna_user', JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('dasna_token');
    localStorage.removeItem('dasna_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
